import React, { useState } from "react";
import { Screenshot } from "./screenshot.types";

interface ScreenshotCardProps {
  screenshot: Screenshot;
  index: number;
}

const ScreenshotCard: React.FC<ScreenshotCardProps> = ({ screenshot }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);

  const openModal = (idx: number = 0) => {
    setImgIndex(idx);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);
  const nextImg = (e: React.MouseEvent) => {
    e.stopPropagation();
    setImgIndex((prev) => (prev + 1) % screenshot.img_urls.length);
  };
  const prevImg = (e: React.MouseEvent) => {
    e.stopPropagation();
    setImgIndex((prev) => (prev - 1 + screenshot.img_urls.length) % screenshot.img_urls.length);
  };

  return (
    <>
      <div
        className="bg-white rounded-2xl overflow-hidden shadow-lg hover:transform hover:-translate-y-3 hover:shadow-2xl transition-all duration-300 cursor-pointer"
        onClick={() => openModal(0)}
        tabIndex={0}
        role="button"
        aria-label={`Expandir imagem de ${screenshot.title}`}
      >
        <div className="h-64 bg-gradient-to-br from-orange-50 to-amber-50 flex items-center justify-center text-6xl text-white relative overflow-hidden">
          {/* <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-white/10"></div> */}
          {screenshot.img_urls && screenshot.img_urls.length > 0 ? (
            <img src={screenshot.img_urls[0]} alt={screenshot.title} className="max-h-full max-w-full object-contain" />
          ) : (
            <span className="relative z-10">{screenshot.icon}</span>
          )}
        </div>
        <div className="p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{screenshot.title}</h3>
          <p className="text-gray-600 text-sm leading-relaxed">{screenshot.description}</p>
        </div>
      </div>

      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
          onClick={closeModal}
        >
          <div className="relative max-w-2xl w-full mx-4" onClick={e => e.stopPropagation()}>
            <button
              className="absolute top-2 right-2 text-white bg-black/50 rounded-full p-2 hover:bg-black/80 transition"
              onClick={closeModal}
              aria-label="Fechar"
            >
              &times;
            </button>
            {screenshot.img_urls.length > 1 && (
              <>
                <button
                  className="absolute left-2 top-1/2 -translate-y-1/2 text-white bg-black/40 rounded-full p-2 hover:bg-black/80 transition"
                  onClick={prevImg}
                  aria-label="Imagem anterior"
                >
                  &#8592;
                </button>
                <button
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-white bg-black/40 rounded-full p-2 hover:bg-black/80 transition"
                  onClick={nextImg}
                  aria-label="Próxima imagem"
                >
                  &#8594;
                </button>
              </>
            )}
            <img
              src={screenshot.img_urls[imgIndex]}
              alt={screenshot.title}
              className="w-full max-h-[80vh] object-contain rounded-xl bg-white"
            />
            {screenshot.img_urls.length > 1 && (
              <div className="flex justify-center gap-2 mt-4">
                {screenshot.img_urls.map((_, idx) => (
                  <button
                    key={idx}
                    className={`w-2 h-2 rounded-full ${idx === imgIndex ? 'bg-orange-500' : 'bg-gray-300'}`}
                    onClick={e => { e.stopPropagation(); setImgIndex(idx); }}
                    aria-label={`Ver imagem ${idx + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ScreenshotCard;